import {
  DateOrNullOrUndefined,
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';
import { formatDateToYmd } from 'src/app/shared/utils/formatDate';
import { parseYMDDate } from 'src/app/shared/utils/DateOrNullOrUndefined';

export interface Location {
  id: number;
  title: string;
}

export class Parent {
  id: number = 0;
  name: string = '';
  surname?: string;
  email: string = '';
  phone: string = '';
  work_phone?: string;
  home_phone?: string;
  birth_date?: Date;
  password?: string = '';
  password_confirmation?: string = '';
  gender: number = 0;
  address?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  location?: Location;
  status: string = '';

  constructor(data: Partial<Parent> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.name = StringOrNullOrUndefined(data.name) ?? '';
    this.surname = StringOrNullOrUndefined(data.surname);
    this.email = StringOrNullOrUndefined(data.email) ?? '';
    this.phone = StringOrNullOrUndefined(data.phone) ?? '';
    this.work_phone = StringOrNullOrUndefined(data.work_phone);
    this.home_phone = StringOrNullOrUndefined(data.home_phone);
    this.birth_date = parseParentDateOnlyValue(data.birth_date);
    this.password = StringOrNullOrUndefined(data.password) ?? '';
    this.password_confirmation = StringOrNullOrUndefined(data.password_confirmation) ?? '';
    this.gender = NumberOrNullOrUndefined(data.gender) ?? 0;
    this.address = StringOrNullOrUndefined(data.address);
    this.city = StringOrNullOrUndefined(data.city);
    this.state = StringOrNullOrUndefined(data.state);
    this.zip_code = StringOrNullOrUndefined(data.zip_code);
    this.location = data.location
      ? {
          id: NumberOrNullOrUndefined(data.location.id) ?? 0,
          title: StringOrNullOrUndefined(data.location.title) ?? '',
        }
      : undefined;
    this.status = StringOrNullOrUndefined(data.status) ?? '';
  }
}

function parseParentDateOnlyValue(value: Date | string | null | undefined): Date | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }

  const normalized = formatDateToYmd(value);
  if (normalized) {
    return parseYMDDate(normalized);
  }

  return DateOrNullOrUndefined(value);
}
